import { Box } from '@mui/material';
import { Fragment } from 'react';

import { EmploymentDetailType } from '~/data/employment/useEmploymentDetails';

import { EmploymentPersonnelGroup } from '../EmploymentPersonnelGroup';

type ExtendedEmploymentDetailType = EmploymentDetailType & {
  [key: `fEmplDetailPersonnelGroup${number}`]: string;
};

type Props = {
  employmentDetails?: ExtendedEmploymentDetailType;
  pendingEmploymentDetails?: ExtendedEmploymentDetailType;
};

export const EmploymentAllPersonnelGroups = ({
  employmentDetails,
  pendingEmploymentDetails,
}: Props) => {
  return (
    <Box component="span">
      {[1, 2, 3, 4, 5].map((index) => (
        <Fragment key={index}>
          <EmploymentPersonnelGroup
            label={`laPerGroup${index}`}
            currentValue={
              employmentDetails?.[`fEmplDetailPersonnelGroup${index}`]
            }
            pendingValue={
              pendingEmploymentDetails?.[`fEmplDetailPersonnelGroup${index}`]
            }
          />
        </Fragment>
      ))}
    </Box>
  );
};
